import * as React from 'react'

export const TranslateBanner = (p: { onClose: () => void }) => {
  return (
    <div className="translate-banner">
      <div className="translate-banner__inner container--l gutter--m">
        <span className="translate-banner__text text--m">
          This site is being translated by Google Translate Services at your request. Want to know more?
          <span> </span>
          <a className="translate-banner__link" href="/disclaimer-engels" target="blank">Read our translation policy</a>
        </span>
        <button onClick={p.onClose}>
          <svg className="translate-banner__icon" aria-hidden="true">
            <use xlinkHref="#icon--close" />
          </svg>
        </button>
      </div>
    </div>
  )
}
